// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4j-6";
export var headerCell = "_4j-2";
export var rowWrapper = "_4j-4";
export var stickyAggregationCell = "_4j-a";
export var stickyAggregationRow = "_4j-7";
export var stickyColumnCell = "_4j-9";
export var stickyColumnHeaderCell = "_4j-8";
export var table = "_4j-1";
export var virtualRowWrapper = "_4j-5";
export var virtualTableContainer = "_4j-0";
export var white = "_4j-3";